module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10022.465a1ed6.jpg";